export default __webpack_public_path__ + "static/media/prisma.03a065f5.jpg";